<template>
  <b-container fluid>
    <b-row>
     <b-col >
        <card>
          <DeviationColorsEditor></DeviationColorsEditor>      
        </card>
      </b-col>
     </b-row>
  </b-container>

</template>

<script>
import DeviationColorsEditor from '@/components/System/DeviationColors/DeviationColorsEditor.vue'

export default {
    name: 'DeviationColors',
    components: {
        DeviationColorsEditor
    }
}
</script>
